import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { Utils } from "./utils/Utils";
import { AudioManager } from "./AudioManager";
import { Language } from "./Types";

export class GameManager {

    public static init(): void {

        GameVars.intitialised = true;
        GameVars.eventsDispatcher = new CardCrawl.EventDispatcher();

        GameVars.isDesktop = GameVars.currentScene.sys.game.device.os.desktop && !(navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform));

        if (GameVars.isDesktop) {

            GameVars.scaleY = 1;

        } else {

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            GameVars.currentScene.game.scale.refresh();

            const aspectRatio = window.innerHeight / window.innerWidth;
            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / aspectRatio;
        }

        if (GameVars.areValidDomains(["unblocked-games", "freezenova.com", "localhost", "127", "0.0.0"])) {
            GameManager.readGameData();
        } 
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {

                    const specialCards: CardCrawl.SpecialCard[] = JSON.parse(JSON.stringify(GameConstants.SPECIAL_CARDS));
                   
                    GameVars.gameData = {
                        muted: false,
                        gold: 0,
                        specialCards: specialCards,
                        tutorialSeen: false,
                        language: Utils.getBrowserLanguage(),
                        numPlayedGames: 0,
                        data: {}
                    };

                    GameManager.writeGameData();
                }

                GameManager.startGame();
            }
        );
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameVars.currentScene = scene;
    }

    public static onGameAssetsLoaded(): void {

        AudioManager.init();

        GameManager.enterSplashScene();
        // GameManager.enterBoardScene();
        // GameManager.enterBoardScene(true);
        // GameManager.enterShopScene();
    }

    public static enterSplashScene(fromShopScene?: boolean, fromLanguageSelection?: boolean): void {

        GameVars.currentScene.scene.start("SplashScene", {fromShopScene: fromShopScene, fromLanguageSelection: fromLanguageSelection});
    }

    public static enterShopScene(): void {

        GameVars.currentScene.scene.start("ShopScene");

        GameVars.currentScene.time.delayedCall(1000, function (): void {
            GameVars.specialCardJustUnlocked = false;
        }, [], GameManager);
    }

    public static enterBoardScene(tutorial?: boolean): void {

        GameVars.eventsDispatcher.removeAllEventListeners();

        if (!GameVars.gameData.tutorialSeen || tutorial) {
            
            GameVars.tutorialMode = true;
            GameVars.gameData.tutorialSeen = true;
            GameManager.writeGameData();

            GameVars.currentScene.scene.start("TutorialScene");

        } else {

            GameVars.tutorialMode = false;

            GameVars.currentScene.scene.start("BoardScene");
        }
    }

    public static resetGame(): void {

        GameManager.enterBoardScene();  
    }

    public static unlockSpecialCard(type: string): void {

        GameVars.specialCardJustUnlocked = true;

        const specialCards = GameVars.gameData.specialCards;

        for (let i = 0; i < specialCards.length; i++) {

            if (specialCards[i].type === type) {

                specialCards[i].unlocked = true;
                GameVars.gameData.gold -= specialCards[i].price;
                break;
            }
        }

        GameManager.writeGameData();

        GameManager.enterShopScene();
    }

    public static setLanguage(lang: Language): void {

        GameVars.gameData.language = lang;
        GameManager.writeGameData();

        GameManager.enterSplashScene();
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    public static logBoard(): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        console.clear();
    }

    private static startGame(): void {

        GameVars.currentScene.scene.start("PreloadScene");
    }
    
    private static getGameStorageData(key: string, successCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {

        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
